///<amd-module name = "Core/Medius.Core.Web/Scripts/Medius/core/validation/email"/>

// source: http://www.w3.org/TR/html5/forms.html#valid-e-mail-address
const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

export const getRegex = () => {
    return emailRegex;
};